import { gql } from 'apollo-angular';
import { Event, EventSubscription } from '../../entities/events/event';
import { Page } from '../../entities/page/page';


export const EVENT_SUBSCRIPTION_QUERY = gql`
query eventSubscriptionQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String, $type: SubscriptionType)
{
  eventSubscriptions: getEventSubscriptionsPaged(
    filter: {
      type: $type,
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection}
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
        id
        externalId
        url
        eventTypes
        lastTriggeredDateTime
        active
        type
        customHtmlHeaders
        secretHash
      }
    }
}
`;

export interface EventSubscriptionsQueryResponse {
  loading: boolean;
  eventSubscriptions:Page<EventSubscription>;
}
